import { useAuthStore } from '@sparkai/auth'
import { UserRoles } from '@sparkai/shared-types'
import { jwtDecode } from 'jwt-decode'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom-v5-compat'

export const TaskOutcome = () => {
  const token = useAuthStore((state) => state.token)
  const decodedToken = jwtDecode(token || '') as Record<string, string>
  const role = decodedToken['https://spark.ai/sparkai-role'] as UserRoles

  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)
  const engagementId = searchParams.get('engagement-id')
  const taskId = searchParams.get('task-id')
  const taskReviewId = searchParams.get('task-review-id')

  useEffect(() => {
    if (role === 'admin') {
      const filter = `(key:tab,value:tasks),(key:taskId,value:${taskId})`
      const origin = window.location.origin.includes('localhost')
        ? 'http://localhost:3001'
        : window.location.origin

      const url = engagementId
        ? `${origin}/admin/engagement/${engagementId}?filters=${btoa(filter)}`
        : `${origin}/admin/`
      window.location.href = url
    } else if (role === 'customer') {
      const origin = window.location.origin.includes('localhost')
        ? 'http://localhost:3004'
        : window.location.origin

      const url = engagementId ? `${origin}/customer/engagement/${engagementId}` : `${origin}/customer/`
      window.location.href = url
    } else {
      const origin = window.location.origin.includes('localhost')
        ? 'http://localhost:3002'
        : window.location.origin

      const url = taskReviewId ? `${origin}/ms/task-review/${taskReviewId}` : `${origin}/ms/`
      window.location.href = url
    }
  }, [engagementId, role, taskId, taskReviewId])

  return (
    <div className='flex h-screen w-full flex-col items-center justify-center bg-brand-gray-50 text-sm text-brand-gray-400'>
      Loading...
    </div>
  )
}
